<template>
    <div class="flex-container">
        <div class="flex-row">
            <h2 :class="title">{{ title }}</h2>
            <a :href="`${url}`" target="_blank">
                <font-awesome-icon :icon="`fa-brands ${iconLink}`" size="xl" class="icon" />
            </a>
        </div>
        <h3>{{ description }}</h3>
        <div class="preview-container">
            <img :src="`../../Projects-assets/${src}.png`" class="project-preview" :alt="`${alt}`">
        </div>
        <div class="flex-row">
            <div class="paragraph-text">
                <p :paragraph1a="paragraph1a">{{ paragraph1a }}</p>
                <p :paragraph2b="paragraph1b">{{ paragraph1b }}</p>
            </div>
        </div>
        <div class="preview-container">
            <img :src="`../../Projects-assets/${src2}.png`" class="project-preview" :alt="`${alt2}`">
        </div>
        <div class="flex-row">
            <div class="paragraph-text">
                <p :paragraph2a="paragraph2a">{{ paragraph2a }}</p>
                <p :paragraph2b="paragraph2b">{{ paragraph2b }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GDProjectComponent',
    props: {
        title: String,
        src: String,
        src2: String,
        srcOther: String,
        description: String,
        paragraph1a: String,
        paragraph1b: String,
        paragraph2a: String,
        paragraph2b: String,
        iconFramework: String,
        iconLink: String,
        alt: String,
        alt2: String,
    }
}
</script>

<style lang="scss" scoped>
//sass typefaces
$primary-font: 'Roboto Mono', monospace;
$font-special: 'Urbanist', sans-serif;
$font-typewriter: 'Courier Prime', monospace;

//sass colors
$primary-color: black;
$secondary-color: gray;
$accent-color: rgb(49, 49, 49);

.flex-container {
    display: flex;
    flex-direction: column;
}

.flex-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.paragraph-text {
    max-width: 400px;
    padding-left: 10px;
    text-align: left;
}
.preview-container {
    margin: auto;
}
.project-preview {
    margin: auto;
    // width: 200px;
    width: 80%;
    height: auto;
    object-fit: cover;
    text-align: center;
}
.icon {
    color: $primary-color;
    padding: 14px 8px 0;
}

</style>